import React from 'react'
import 'tippy.js/dist/tippy.css'

import { ExploreState } from 'clientPages/explore/types'
import FilterSection from './FilterSection'

export interface FilterProps {
  exploreState: ExploreState
  setExploreState: React.Dispatch<React.SetStateAction<ExploreState>>
}

/* Could delete this file but leaving in case we have to add defs section later*/
const FilterBar = ({
  exploreState,
  setExploreState,
}: FilterProps): JSX.Element => {
  return <FilterSection {...{ exploreState, setExploreState }} />
}

export default FilterBar
